'use client'
import { ButtonRoundStyle, Icon } from '@/components'
import { CALLBACK_URL_KEY } from '@/constants'
import { Stack } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import { TitleLoginForm } from '../../components'
import { LoginForm, OTPForm } from './components'

type Props = {
  socialLoginUrls?: any[]
  goToRegisterPage?: () => void
  goToForgotPasswordPage?: () => void
}

export const LoginPage = ({ socialLoginUrls, goToRegisterPage, goToForgotPasswordPage }: Props) => {
  const t = useTranslations('UserProfile')
  const [step, setStep] = useState<'LOGIN' | 'OTP'>('LOGIN')
  const [phoneNumber, setPhoneNumber] = useState<string>('')
  const searchParams = useSearchParams()

  return (
    <Stack
      spacing={{
        xs: 2,
      }}
    >
      <TitleLoginForm title={t('Nhập email số điện thoại của bạn để đăng nhập ngay')} align="center" />

      {/* step mặc định, form đăng nhập */}
      {step === 'LOGIN' && (
        <>
          {socialLoginUrls && socialLoginUrls.length > 0 && (
            <ButtonRoundStyle
              LinkComponent={'a'}
              href={socialLoginUrls?.find((item) => item.key === 'google')?.login_url || '#'}
              onClick={() => {
                localStorage.setItem(CALLBACK_URL_KEY, searchParams.get(CALLBACK_URL_KEY) || '/')
              }}
              variant="outlined"
              sx={{
                gap: 1,
                '&.Mui-disabled': {
                  opacity: 0.6,
                },
              }}
            >
              <Icon.Google /> {t('Đăng nhập bằng Google')}
            </ButtonRoundStyle>
          )}

          <LoginForm
            onOtpSuccess={(phone) => {
              setPhoneNumber(phone)
              setStep('OTP')
            }}
            goToRegisterPage={goToRegisterPage}
            goToForgotPasswordPage={goToForgotPasswordPage}
          />
        </>
      )}
      {/* step nhập mã OTP */}
      {step === 'OTP' && (
        <OTPForm
          phone={phoneNumber}
          onBack={() => setStep('LOGIN')}
          onSuccess={() => {}}
          // onSuccess={() => setStep('UPDATE_PROFILE')}
        />
      )}
    </Stack>
  )
}
